import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TemrVisitAllergyService {
  temrVisitAllergy: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'temr_visit_allergy/list/?';
  private ListRecordByPatientId = webapi + 'temr_visit_allergy/listbyid/?';
  private AddRecord = webapi + 'temr_visit_allergy/create';
  private AddRecordNew = webapi + 'temr_visit_allergy/createNew';
  private EditRecord = webapi + 'temr_visit_allergy/update';
  private GetRecord = webapi + 'temr_visit_allergy/byid/';
  private DeleteRecord = webapi + 'temr_visit_allergy/delete/';
  private GetAllRecordByPatientId = webapi + 'temr_visit_allergy/getAllRecordByPatientId/';
    private ContarindicatedListRecordByPatientId = webapi + 'temr_visit_allergy/contarindicatedlistbyid/?';

  constructor(private http: Http) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordByPatientIdService(currentPage: any, size: any, patientId: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecordByPatientId + 'page=' + currentPage + '&size=' + size + '&patientId=' + patientId + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordServiceNew(model: any) {
    return this.http.post(this.AddRecordNew, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordByPatientId(patientId: any) {
    return this.http.get(this.GetAllRecordByPatientId + patientId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
    getContarindicatedByPatientId(currentPage: any, size: any, patientId: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ContarindicatedListRecordByPatientId + 'page=' + currentPage + '&size=' + size + '&patientId=' + patientId + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/temr-visit-allergy/temr-visit-allergy.service.ts